const timeOfDayList = [
    {label: "Morning", value: "Morning"},
    {label: "Afternoon", value: "Afternoon"},
    {label: "Evening", value: "Evening"},
]

export {timeOfDayList}